var map = {
	"./hsk1.json": 668,
	"./hsk2.json": 1978,
	"./hsk3.json": 2956,
	"./hsk4.json": 4210,
	"./hsk5.json": 2211,
	"./hsk6.json": 8950,
	"./kids.json": 7050,
	"./labo1.json": 4825,
	"./labo2.json": 1132,
	"./labo3.json": 3177,
	"./labo4.json": 4370,
	"./labo5.json": 4253,
	"./labo6.json": 8949,
	"./unpaz-yantaohui-1.json": 1889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5466;